import _ from 'lodash';
import produce from 'immer';
import { v4 as uuidv4 } from 'uuid';

import { API, SET_OFFLINE_MODE, SET_STORY, UPDATE_ANSWERS } from 'client/constants/actions';

type UserState = {
	isRegistered: boolean;
	isOffline: boolean;
	storyPageViewId: null | string;
	answers: {
		// cardID
		[key: string]:
			| {
					selected: string[];
					votes: {
						// answerId
						[key: string]: number;
					};
			  }
			| undefined;
	};
	email?: string;
	google?: {
		email: string;
		id: string;
		name: string;
		picture: string;
	};
	facebook?: { id: string };
	sms?: { id: string };
	guest?: boolean;
	id?: string;
	organizationId?: string;
	provider?: 'google';

	// available only if "oncePerUser: true"
	checkpoint?: {
		cardId: string;
		date: string;
	};
};

const initialState: UserState = {
	isRegistered: false,
	isOffline: false,
	storyPageViewId: null,
	answers: {},
};

export default function userReducer(state = initialState, { type, payload }): UserState {
	return produce(state, draft => {
		switch (type) {
			/* eslint-disable no-param-reassign */
			case API.GET_USER_DATA.SUCCESS:
				Object.assign(draft, {
					isRegistered: _.has(payload, 'id'),
					...payload,
				});
				break;

			case API.REGISTER_GUEST.SUCCESS:
				_.set(draft, 'isRegistered', true);
				break;

			case SET_OFFLINE_MODE:
				_.set(draft, 'isOffline', payload);
				break;

			case SET_STORY:
				_.set(draft, 'storyPageViewId', uuidv4());
				break;

			case API.GET_GAME.SUCCESS:
			case API.START_GAME.SUCCESS:
				if (payload?.game) {
					_.set(draft, 'storyPageViewId', payload.game.pageViewId);
					_.set(draft, 'checkpoint', payload.game.checkpoint);
				}
				break;

			case UPDATE_ANSWERS:
				draft.answers[payload.cardId] = {
					selected: [...(draft.answers[payload.cardId]?.selected || []), payload.answerId],
					votes: payload.votes,
				};
				break;

			default:
				break;
			/* eslint-enable no-param-reassign */
		}
	});
}
